/** The custom role the customer creates in ClickHouse Cloud for the
 * connector's API key. */
export const CLICKHOUSE_CONNECTOR_ROLE = "p0-connector";

/** The permissions the `p0-connector` role holds, in the order the installer
 * lists them. They're the connector's `CLICKHOUSE_REQUIRED_PERMISSIONS`
 * (p0-connector-clickhouse), in its order. Its install check probes every one
 * but `control-plane:service:manage-query-api-endpoints`, which P0 first uses
 * when a lookup sets up P0's Query API endpoint on a service. */
export const CLICKHOUSE_REQUIRED_PERMISSIONS = [
  "control-plane:organization:view",
  "control-plane:organization:manage",
  "control-plane:service:view",
  "control-plane:service:view-query-api-endpoints",
  "control-plane:service:manage-query-api-endpoints",
  "control-plane:organization:view-api-keys",
] as const;

/** The system role the API key holds besides `p0-connector`. ClickHouse
 * documents it as what running a Query API endpoint needs. */
export const CLICKHOUSE_API_KEY_SYSTEM_ROLE = "Basic Service API Reader";
